<template>
    <li class="ac_collapse__item">
        <!--        {{news.fpDocumentInfo.newsHtmlUuid}}-->
        <!--        <div v-if="news.fpDocumentInfo.newsHtmlUuid"></div>-->
        <a class="ac_collapse__link accordion-item-link " @click.prevent='openModal(news)'
            :class="{ ' news-breaking': news.fpDocumentInfo.newsBreaking === '1' }" href="#">

            <span class="news-link-date">{{ moment(news.newsPublishedDateTime).format('D. MMM').toLowerCase() }} </span>
            <span class="news-link-title"> {{ news.fpDocumentInfo.newsShortText }}</span>
        </a>
        <!--        <a v-else   class="ac_collapse__link accordion-item-link "-->
        <!--            @click.prevent-->
        <!--            :class="{' news-breaking':news.fpDocumentInfo.newsBreaking==='1'}"-->
        <!--            href="#">-->
        <!--            <span class="news-link-date">{{moment(news.newsPublishedDateTime).format('D. MMM')}}  </span>-->
        <!--            <span class="news-link-title"> {{news.fpDocumentInfo.newsShortText}}</span>-->
        <!--        </a>-->

        <news-single-modal :id="modalId" :title="news.fpDocumentInfo.newsShortText" :iframeUrl="iframeUrl"
            :fullText="fullText" :close="closeModal"></news-single-modal>
    </li>
</template>

<script>

import NewsSingleModal from '@/components/NewsSingleModal.vue';



export default {
    name: "NewsListElementComponent",
    data() {
        return {
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
            modalContent: null,
            iframeUrl: '',
            modalId: '',
            fullText: ''
        }
    },
    components: {
        NewsSingleModal,
    },
    props: ['news'],
    watch: {
        news: {
            handler(val) {
                if (val) {
                    this.iframeUrl = (this.news && this.news.fpDocumentInfo.newsHtmlUuid) ? this.baseApiUrl + 'prins/GetDocTypeHtml?uuid=' + this.news.fpDocumentInfo.newsHtmlUuid + '&id=' + this.news.fpDocumentInfo.newsId + '&doctype=fpnews' : null;
                    this.modalId = 'news_modal_' + this.news.fpDocumentInfo.newsId;
                    this.fullText = this.news.fpDocumentInfo.newsFullText;
                }
            },
            deep: true
        }
    },
    mounted() {
        this.iframeUrl = (this.news && this.news.fpDocumentInfo.newsHtmlUuid) ? this.baseApiUrl + 'prins/GetDocTypeHtml?uuid=' + this.news.fpDocumentInfo.newsHtmlUuid + '&id=' + this.news.fpDocumentInfo.newsId + '&doctype=fpnews' : null;
        this.modalId = 'news_modal_' + this.news.fpDocumentInfo.newsId;
        this.fullText = this.news.fpDocumentInfo.newsFullText;
    },
    methods: {
        openModal(newsItem) {
            if (newsItem.fpDocumentInfo.newsDirectLink) {
                if (newsItem.fpDocumentInfo.newsDirectLink.includes("NP")) {
                    this.$router.push('/slglrsNP-overview/all');
                } else if (newsItem.fpDocumentInfo.newsDirectLink.includes("MUTG")) {
                    this.$router.push('/slglrsMUTG-overview/all');
                } else if (newsItem.fpDocumentInfo.newsDirectLink.includes("PG2010")) {
                    this.$router.push('/slglrsPG2010-overview/all');
                }
            } else if (newsItem.fpDocumentInfo.newsIncludeInSearchResult != "0") {
                this.$bvModal.show(this.modalId);
            }
        },
        closeModal() {
            this.modalIframeUrl = null;
            this.fullText = '';
        },
    }
}
</script>

<style scoped>
@media(max-width: 800px) {
    #news_modal_17832___BV_modal_title_ {
        font-size: 12px !important;
        text-align: center;
        font-weight: 600;
    }

    .modal-title {
        font-size: 12px !important;
        text-align: center;
        font-weight: 600;
    }

    .mb-2 .mb-md-0 {
        font-size: 12px !important;
        text-align: center;
        font-weight: 600;
    }

    .modal-header {
        font-size: 12px !important;
        text-align: center;
        font-weight: 600;
    }
}
</style>
